// @ts-check

import "./jsdoc-types"
import { Typography } from "@bonprix/design-system";
import classNames from "classnames";
import { PageComponentsRenderer } from "./ComponentRenderer.jsx";

/**
* @param {Object} props
* @param {ServicePageContentfulModel} props.model
*/
export function ServicePageContent({ model }) {
	return (
		<div className="content-platform__service-page">
			{model.parsedCdaEntry.fields.headline && (
				<div className={classNames("content-platform__service-page__headline", {
					"text-align-left": !model.parsedCdaEntry.fields.headlineAlignment || model.parsedCdaEntry.fields.headlineAlignment === "left",
					"text-align-center": model.parsedCdaEntry.fields.headlineAlignment === "center",
					"text-align-right": model.parsedCdaEntry.fields.headlineAlignment === "right",
				})}>
					<Typography variant="bonprix-h1" component="h1">{model.parsedCdaEntry.fields.headline}</Typography>
				</div>
			)}

			<PageComponentsRenderer cdaEntries={ model.parsedCdaEntry.fields.content } pageCdaEntry={model.parsedCdaEntry} />
		</div>
	);
}
